export default __webpack_public_path__ + "static/media/40.639e6a41.jpeg";